import React, { useState } from 'react'
import { Card, H5 } from '@blueprintjs/core'
import piloted from '../../assets/piloted.png'
import autonomous from '../../assets/autonomous.png'
import FadeIn from 'react-fade-in'
import { useEffect } from 'react'

const SessionType = ({ onInputChange, goNextStep, nextStep, type }) => {

    const [selectedCard, setSelectedCard] = useState(false)

    const goAutonomous = () => {
        onInputChange('type', 'AUTONOMOUS')
        goNextStep(nextStep)
        setSelectedCard('AUTONOMOUS')
    }

    const goPiloted = () => {
        onInputChange('type', 'PILOTED')
        setSelectedCard('PILOTED')
        goNextStep(nextStep)
    }

    useEffect(() => {
        if (type && type === 'AUTONOMOUS') goAutonomous()
        if (type && type === 'PILOTED') goPiloted()
        // eslint-disable-next-line
    }, [])

    return (
        <Card>
            <FadeIn>
                <div className="type-choice margin-top-medium margin-bottom-large">
                    <div
                        className={selectedCard === 'AUTONOMOUS' ? 'typeCardSelected' : 'typeCard'}
                        onClick={goAutonomous}
                    >
                        <img src={autonomous}
                            alt="proto1"
                            className='img-responsive'
                        />
                        <H5 className='text-center'>AUTONOMOUS</H5>
                        <p className='typeDesc'>
                            The participant can access the session individually from a computer.
                            <br /> He does the session at his own pace and takes the time needed to complete the votes.
                            <br /> You just need to send him the link to the session
                        </p>
                    </div>
                    <div
                        className={selectedCard === 'PILOTED' ? 'typeCardSelected' : 'typeCard'}
                        onClick={goPiloted}
                    >
                        <img src={piloted}
                            alt="proto1"
                            className='img-responsive'
                        />
                        <H5 className='text-center'>PILOTED</H5>
                        <p className='typeDesc'>
                            The course of this session is managed by you or a third party with a video projector.
                            <br /> The organisator of session will have the opportunity to comment on different images and manage the pace of the session.
                            <br />The participants are voting using their smartphones.
                        </p>
                    </div>
                </div>
            </FadeIn>
        </Card>
    )
}

export default SessionType
